<template>
    <div class="flex flex-column gap-3">
        <div class="flex justify-content-between">
            <Skeleton width="10rem" class="mb-2" borderRadius="16px" />
            <Skeleton width="5rem" class="mb-2" borderRadius="16px" />
        </div>
        <!-- accordion header -->
        <Skeleton height="1rem" class="mb-2" borderRadius="16px" />

        <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
        <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />

        <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
        <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />

        <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />

        <div class="flex gap-3">
            <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />
            <div class="flex flex-column gap-2 justify-content-center align-items-center">
                <span class="text-center"> Loading Task Details..</span>
                <MoonLoader />
            </div>
        </div>

        <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
        <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />

        <div class="flex justify-content-between">
            <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />
            <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />
        </div>
        <div class="flex justify-content-between">
            <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
            <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
        </div>
        <div class="flex justify-content-between">
            <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />
            <Skeleton width="15rem" height="1rem" class="mb-2" borderRadius="16px" />
        </div>
        <div class="flex justify-content-between">
            <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
            <Skeleton width="10rem" height="1rem" class="mb-2" borderRadius="16px" />
        </div>
    </div>
</template>

<script setup></script>
